import { apiAuth, apiResponseType } from ".";

export const getStockistsData = (
  page: number = 1,
  unity_id?: string
): apiResponseType =>
  apiAuth.get(`users/stockists?page=${page}${unity_id ? `&unity_id=${unity_id}` : ""}`);

export const registerStockistsData = (data: any) =>
  apiAuth.post("/users/stockists/store", data) as apiResponseType;

export const deleteStockistsData = (uuid: string) =>
  apiAuth.delete(`users/stockists/${uuid}/destroy`) as apiResponseType;

export const updateStockistsData = (uuid: string, data: any) =>
  apiAuth.put(`users/stockists/${uuid}/update`, data) as apiResponseType;

export const getShowStockists = (uuid: string) =>
  apiAuth.get(`users/stockists/${uuid}/show`) as apiResponseType;

export const searchStockistsData = (params: {
  name: string;
  unity_id?: string;
}): apiResponseType =>
  apiAuth.get(
    `users/stockists?name=${params.name}${
      params.unity_id ? `&unity_id=${params.unity_id}` : ""
    }`
  );

export const setStatusStockists = (uuid: string) =>
  apiAuth.put(`users/stockists/${uuid}/toggle-status`) as apiResponseType;

export const getSelectStockists = (params: { unity_id?: string; name?: string }) =>
  apiAuth.get(
    `users/stockists/select?${params.unity_id ? `unity_id=${params.unity_id}` : ""}${
      params.name ? `&name=${params.name}` : ""
    }`
  ) as apiResponseType;